var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('MatchingSearch'),_c('MatchingProducts'),_c('b-card',[_c('b-button-group',[_c('b-button',{attrs:{"title":"Seçili olanları eşleştir","variant":"success"},on:{"click":_vm.setSelectedMatching}},[_vm._v("Eşleştir ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }